import { SETTINGS_SECTIONS } from './settings';

export const CORE_SETUP_LABELS = {
    fields: `Configure ${SETTINGS_SECTIONS.selectorFields.toLowerCase()}`,
    records: 'Add fitment records',
    products: 'Connect products to fitments',
    storefront: 'Configure storefront behavior',
} as const;

export const SETUP_STATUS_LABELS = {
    complete: 'Complete',
    action: 'Action required',
    optional: 'Optional',
    recommended: 'Recommended',
    unverified: 'Not verified',
    'not-applicable': 'Not applicable',
} as const;

export type SetupRowStatus = keyof typeof SETUP_STATUS_LABELS;
